
/**
 * 當打開modal時overflow=hidden
 * 但modal在切換(A modal已開啟情況下，打開B modal自動關閉A)時，overflow!=hidden，導致顯示上下拉桿
 * 此JS用於解決此問題
 */
import $ from "jquery";
import CookieUtil from "@/assets/js/util/CookieUtil.js";
import eventBus from '@/assets/js/event/EventBus.js'

const loginModal = "loginModal";

// 判斷是否初始化
let isInit = false;

/**
 * *-Modal:
 * element id
 * 
 * isCoexist:
 * 1.false: 當別的modal開啟時自己會被關閉
 * 2.true: 當別的modal開啟時自己不會被關閉
 */
const modalIdObj = {
    "changeEmailModal": { "isCoexist": false },
    "changePasswordModal": { "isCoexist": false },
    "emailLoginModal": { "isCoexist": false },
    "forgotAccountModal": { "isCoexist": false },
    "forgotPasswordModal": { "isCoexist": false },
    "loginModal": { "isCoexist": false },
    "registerModal": { "isCoexist": false },
    "registerEmailModal": { "isCoexist": false },
    "serverErrorQuickReportModal": { "isCoexist": false },
    "memberModal": { "isCoexist": true },
}

// 當前已開啟的modal
const modalOpenList = [];

function init() {
    if ($ != undefined && $ != null && isInit == false) {
        // 初始化
        isInit = true;

        // 欲綁定事件之modal element id
        const modalIdList = Object.keys(modalIdObj);

        // 對modal element id綁定事件
        for (let i = 0; i < modalIdList.length; i++) {
            const modalId = modalIdList[i];
            // 綁定 欲打開modal 的事件
            $('#' + modalId).on('show.bs.modal', function () {
                modalOpenList.push(modalId);
                // 關閉其餘是開啟但isCoexist=false的modal
                for (let j = 0; j < modalOpenList.length; j++) {
                    const modalOpenId = modalOpenList[j];
                    if (modalId != modalOpenId && modalIdObj[modalOpenId].isCoexist == false) {
                        $('#' + modalOpenId).modal('hide');
                    }
                }
                if (modalOpenList.length > 0) {
                    document.body.classList.add("cm-modal-overflow-hidden");
                }

                // 依照不同modalId做處理
                if(modalId == "loginModal") {
                    eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_OPEN_MODAL_LOGIN);
                }
            })

            // 綁定 欲關閉modal 的事件
            $('#' + modalId).on('hide.bs.modal', function () {
                additionalProcessBeforeCloseModal(modalId);
                const index = modalOpenList.indexOf(modalId)
                if (index != -1) {
                    modalOpenList.splice(index, 1)
                    // 當前沒有開啟的modal則移除css
                    if (modalOpenList.length == 0) {
                        document.body.classList.remove("cm-modal-overflow-hidden");
                    }
                }
            })
        }
    }
}


/**
 * 關閉modal前作一些額外處理
 */
function additionalProcessBeforeCloseModal(modalId) {
    if (modalId == loginModal) {
        CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH)
        CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_HISTORYLIST_QUERY_CS)
    }
}

/**
 * 將在modalOpenList裡的所有element id的modal都關閉
 */
function closeAllModal() {
    const cloneModalOpenList = JSON.parse(JSON.stringify(modalOpenList));
    for (let i = 0; i < cloneModalOpenList.length; i++) {
        const modalId = cloneModalOpenList[i];
        $("#" + modalId).modal('hide');
    }
}

export { init, closeAllModal }